import React from 'react';
import DriveGallery from '../../components/DriveGallery';

const KotlikovyGulas = () => (
  <DriveGallery
    galleryId="kotlikovy-gulas"
    title="Kotlíkový guláš"
  />
);

export default KotlikovyGulas;
